import * as _4 from 'lodash';

type RequestAPI = any;
type TInfoIO<UNUSED> = any;

export class APIRequestSGDToSTCAuthorization {
  readonly id = 'api-sgd-to-stc-authorization';
  readonly type = 'request';

  constructor(
    private sTCAPIAdatper: STCAPIAdatper,
    private appConfigModel: any,
    private authToken: any,
    private $http: ng.IHttpService,
    private accountModel: any
  ) {}

  async invoke(infoIO: TInfoIO<RequestAPI>) {
    const sTCAPIAdatper = this.sTCAPIAdatper;
    const campusUrl = this.appConfigModel.getConfigProperty(`core-campus_url`);
    const isCampusAPI = sTCAPIAdatper.isCampusAPI(infoIO.uri, campusUrl);

    if (!isCampusAPI) {
      // a hack probably only needed for hi-http
      //
      await sTCAPIAdatper.dummyPromise();

      // Update headers with the authorization token to resolve the issue where the micro app shows a missing token notification when a student navigates to the desktop app via deep links.
      if (this.__isAuthorizationTokenEmpty(infoIO)) {
        const token = this.accountModel.token;
        const authorizationToken = `Token ${token}`;

        this.__updateHeaders(infoIO, authorizationToken);
      }

      return infoIO;
    }

    infoIO.uri = sTCAPIAdatper.prefixCampusURI(infoIO.uri, campusUrl);

    const needsJWT = sTCAPIAdatper.needsJWTToken(infoIO.uri);

    const accessToken = needsJWT ? await sTCAPIAdatper.fetchJWTToken() : await this.authToken.getToken();

    const authorizationToken = needsJWT ? `${accessToken}` : `Bearer ${accessToken}`;

    this.__updateHeaders(infoIO, authorizationToken);

    return infoIO;

  }

  private __updateHeaders(infoIO, authorizationToken) {
    infoIO.packet.headers = infoIO.packet.headers || {};
    infoIO.packet.headers = Object.assign(infoIO.packet.headers, {
      Authorization: authorizationToken
    });
  }

  private __isAuthorizationTokenEmpty(infoIO: any) {
   return _4.isEmpty(_4.get(infoIO, 'options.authorization.token'));
  }

}

/**
 * a collection of functions used to decorate API calls for
 * hi-http and pi-io so we can make calls to STC/API endpoints
 */
export class STCAPIAdatper {
  constructor(
    private appConfigModel: any,
    private authToken: any,
    private $http: ng.IHttpService,
    private accountModel: any
  ) { }

  dummyPromise() {
    return Promise.resolve(undefined);
  }

  fetchJWTToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.$http
        .get('core/client_jwt')
        .then((response: { data: { access_token: string } }) => {
          return resolve(response.data.access_token);
        })
        .catch((e: Error) => {
          return reject(e);
        });
    });
  }

  /*
    reportsAPIs (including appt summ, notes, progress report) =
      /api/v3/students/[student id]/...
    pronounsAPIs =
      /api/v3/student_resources/pronouns?primary_user_ids=[student id]
    self alerts APIs =
      /api/v3/student_resources/alerts/form_options
      /api/v3/student_resources/alerts

    This function returns true (needs JWT token) for the above URLs

    student scheduling APIs =
      /api/v3/student_resources/...
    followed by options including schedulable, visitable, requestable, confirm_appointment, appointments, appointment_campaigns/scheduler_times, appointment_campaigns/appointments, etc.etc.etc.

    This function returns false for the above student scheduling URLs
  */
  needsJWTToken(uri: string) {
    return ['api/v3/students', 'pronouns', 'alerts'].some((str) => uri.includes(str));
  }

  isCampusAPI(uri: string = '', campusUrl: string) {
    if (_4.isEmpty(campusUrl)) {
      return false;
    }

    const implicitCampusURI = uri.includes('/api/v2') || uri.includes('/api/v3');
    return uri.includes(campusUrl) || implicitCampusURI;
  }

  isSGDAPI(uri: string = '') {
    return uri.includes('/api/v1');
  }

  prefixCampusURI(api: string = '', campusUrl: string) {
    const APISeparator = '/api/';
    const relativeURI = api.split(APISeparator)[1];

    return `${campusUrl}${APISeparator}${relativeURI}`;
  }

  handleHTTPError(error: Error) {
    window['HIP'].fn.notify({
      title: 'Service Unavailable',
      details: 'This service is temporarily unavailable, please check your network or try again at a later time.'
    });

    return Promise.reject(error);
  }

  createHTTPPointCut(httpInvokeFn: Function) {
    const that = this;

    return async function (this: any, httpPayload: any) {
      const campusUrl = that.appConfigModel.getConfigProperty(`core-campus_url`);
      const isCampusAPI = that.isCampusAPI(this.uri, campusUrl);

      await that.dummyPromise();

      if (!isCampusAPI) {
        return httpInvokeFn.call(this, httpPayload).catch((e) => this.handleHTTPError(e));
      }

      this.uri = that.prefixCampusURI(this.uri, campusUrl);

      const needsJWT = that.needsJWTToken(this.uri);

      const accessToken = needsJWT ? await that.fetchJWTToken() : await that.authToken.getToken();

      const authorizationToken = needsJWT ? `${accessToken}` : `Bearer ${accessToken}`;

      this.headers = Object.assign(this.headers, {
        Authorization: authorizationToken
      });

      return httpInvokeFn.call(this, httpPayload).catch((e) => this.handleHTTPError(e));
    };
  }

  createIOInterceptor() {
    return new APIRequestSGDToSTCAuthorization(this, this.appConfigModel, this.authToken, this.$http, this.accountModel);
  }
}



// WEBPACK FOOTER //
// ./app/lib/core/configs/stc_integration.ts